import React, {useEffect, useMemo, useState} from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import AppointmentDetails from '../AppointmentDetails';
import AppointmentApproved from '../AppointmentApproved';
import AppointmentCanceled from '../AppointmentCanceled';
import ConfirmationButtons from '../ConfirmationButtons';
import Map from '../GoogleMap';
import Notes from '../Notes';
import { ErrorHandler } from '../Errors/ErrorHandler';
import buttonsBackground from '../../images/buttons_bg.svg';
import AppointmentExpired from '../AppointmentExpired';
import Main from '../Main';

const AppointmentStatus = {
    New: 0,
    Confirmed: 2,
    Canceled: 99
}

const getNotes = (appointment) => {
    return appointment?.note?.length ? <Notes appointment={appointment} /> : null;
}

const expiredText = () => {
    return <div>
        <div>אנו מצטערים, מועד אישור תור זה עבר ואינו זמין עוד.</div>
        <div>במידה ויתפנה תור נוסף בעתיד, תשלח לך הודעה.</div>
    </div>
}

export const WaitingList = () => {
    const [appointment, setAppointment] = useState(null);
    const [status, setStatus] = useState(200);
    const [hasError, setHasError] = useState(false);
    const { id } = useParams();

    async function fetchAppointment() {
        return axios.get('/waitinglists/get?appointmentGuid=' + id + '&browserWidth=' + window.innerWidth)
            .then(response => {
                setAppointment(response.data);
                setStatus(response.status);
            })
            .catch(error => {
                setStatus(error.response.status);
            });
    }
    function displayCancelledText() {
        setAppointment(prev => prev ? { ...prev, status: AppointmentStatus.Canceled } : prev);
    }

    useEffect(() => {
        fetchAppointment();
    }, []);

    let notes = getNotes(appointment);
    let buttonsComponent= useMemo(()=> {
        switch (appointment?.status) {
            case AppointmentStatus.Confirmed:
                let text = `תודה רבה, תור ${appointment.type} נקבע ל-${appointment.date} ב-${appointment.time}`;
                return <AppointmentApproved text={text} />;
            case AppointmentStatus.Canceled:
                return <AppointmentCanceled declinedText={appointment?.appointmentDeclinedText} />;
            case AppointmentStatus.New:
            default:
                return    <ConfirmationButtons
                        id={id}
                        title={"האם לקבוע לך?"}
                        approveText={"תקבעו לי"}
                        disapproveText={"אל תקבעו"}
                        onCancelClick={displayCancelledText}
                        method={"waitinglists"}
                        error={() => setHasError(true)}
                        callback={fetchAppointment}
                        showSpinnerOnClick={true}
                    />;
                break;
        }
    }, [appointment])

    let content;

    if (appointment) {
        if (moment() > moment(appointment.pageExpiryDate, "YYYY-MM-DD HH:mm:ss")) {
            content =
                <Main appointment={appointment}>
                    <AppointmentExpired doctorName={appointment.doctorName} expiredText={expiredText} />
                </Main>;
        } else {
            content =
                <Main appointment={appointment} title={"התפנה תור"}>
                    <AppointmentDetails error={hasError} appointment={appointment} />
                    <div className="container">
                        <div id="confirmation_buttons" className="d-flex justify-content-center align-items-center flex-column" style={{ backgroundImage: `url(${buttonsBackground})` }}>
                            {buttonsComponent}
                        </div>
                    </div>
                    {notes}
                    <Map appointmentId={appointment.id} address={appointment.clinicAddress} location={appointment.clinicLocation} />
                </Main>;
        }
    } else if (status === 204) {
        content = <Main appointment={appointment}>
                    <AppointmentExpired doctorName={appointment.doctorName} expiredText={expiredText}/>
                  </Main>;
    }else if (status !== 200) {
        content = <ErrorHandler status={status} />;
    } else {
        content = null;
    }

    return content;
}